import React from 'react';
import moment from 'moment';

import Invoice from '../../types/invoice';
import { currencyNumberFormat } from '../../../../utilities/number-format';
import {
  CardListItem,
  CardContent,
  Label,
  Value,
  DetailsLink,
  PayButton
} from './InvoiceCardListItem.styled';

interface Props {
  invoice: Invoice;
  onPayClick: () => void;
}

const InvoiceCardListItem = ({ invoice, onPayClick }: Props) => {
  const { dateOfInvoice, service, balance, id, azEncounterIdentifier, paidViaPpApp } = invoice;

  const canPayInvoice = !paidViaPpApp && parseInt(balance) > 0;

  return (
    <CardListItem>
      <CardContent>
        <Label>date of service</Label>
        <Value>{moment(dateOfInvoice).format('MM/DD/YYYY')}</Value>

        <Label>service</Label>
        <Value>{service}</Value>

        <Label>balance</Label>
        <Value>
          {currencyNumberFormat(balance)}
          {canPayInvoice && <PayButton onClick={onPayClick}>Pay</PayButton>}
        </Value>

        <Label>invoice details</Label>
        <Value>
          <DetailsLink to={`/invoices/${id}`}>View details</DetailsLink>
        </Value>

        <Label>invoice no</Label>
        <Value>{azEncounterIdentifier || id}</Value>
      </CardContent>
    </CardListItem>
  );
};

export default InvoiceCardListItem;
